var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaypalLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.045,
    height: 22.1
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009ee3",
    d: "M8.125 5.2h6.4c3.4 0 4.7 1.7 4.5 4.2-.3 4.1-2.9 6.4-6.2 6.4h-1.7c-.5 0-.8.3-.9 1.1l-.7 4.7a.472.472 0 01-.5.5h-4c-.4 0-.5-.3-.4-.9l2.4-15c.1-.8.4-1 1.1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#113984",
    d: "M4.125 0h6.4c1.8 0 3.9.1 5.3 1.3a3.975 3.975 0 011.3 3.5c-.4 4.7-3.3 7.4-7.2 7.4h-3.1c-.5 0-.9.3-1 1.3l-.9 5.4c-.1.4-.2.6-.5.6h-3.9c-.4 0-.6-.3-.5-1L2.825 1c.1-.7.5-1 1.3-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#172c70",
    d: "M5.925 12.9l1.1-6.9a.955.955 0 011.1-.9h6.4a6.326 6.326 0 012.6.5c-.6 4.2-3.4 6.6-7.1 6.6h-3.1a.963.963 0 00-1 .7z"
  }))));
}
export default SvgPaypalLogo;